import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import { Typography, WindowTitle } from '@homeviews/shared-ui'
import type { ITheme } from '@homeviews/styles'

import { useGetCompaniesQuery } from '@homeviews/store'
import type { Company } from '@homeviews/models'
import { CompanyCard } from '@homeviews/companies'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
    footerMessage: {
      marginTop: theme.spacing(4),
      textAlign: 'center',
    },
  }),
)
const Companies: React.FC = () => {
  const classes = useStyles()

  const { data: response, isFetching } = useGetCompaniesQuery()

  const companies = response?.data || []

  return (
    <>
      <WindowTitle title="Companies" />
      <div className={classes.root}>
        <Typography variant="h1">Companies</Typography>
        {!isFetching &&
          !!companies?.length &&
          companies.map((company: Company) => (
            <CompanyCard
              key={company.id}
              {...company}
              logo={company?.logo?.custom_properties?.url}
            />
          ))}
        <Typography className={classes.footerMessage}>
          To edit your company description, please contact your account manager
        </Typography>
      </div>
    </>
  )
}

export default Companies
